export const GOOGLE_MARKETING_PLATFORM_MACHINE_NAME = 'a_google_marketing_platform';
export const GOOGLE_CAMPAIGN_MANAGER_360_SHORTCUT = 'cm360';
export const GOOGLE_DISPLAY_VIDEO_360_SHORTCUT = 'dv360';
